import { createAsyncThunk } from '@reduxjs/toolkit';
import { buildBomData } from 'pcb-parts/utils/builders';
import { selectDataForBomSave } from 'pcb-parts/slice/selectors';
import {
  getBomLineItemSubstitutes,
  saveBomOnStore,
  searchSubstitutes,
} from 'pcb-parts/actions/bomQuote';

export const saveBomData = createAsyncThunk(
  'bomSlice/saveBomData',
  async (id, thunkAPI) => {
    const bom = selectDataForBomSave(thunkAPI.getState());
    return saveBomOnStore(id, { bom: buildBomData(bom), variant_id: bom.currentVariant });
  }
);

export const getSubstitutes = createAsyncThunk(
  'bomSlice/getSubstitutes',
  async (bom_line_item_id) => getBomLineItemSubstitutes(bom_line_item_id)
);

export const searchPossibleSubstitutes = createAsyncThunk(
  'bomSlice/searchPossibleSubstitutes',
  async (params) => {
    const { bom_line_item_id, keyword } = params;
    return searchSubstitutes(bom_line_item_id, keyword);
  }
);